var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { createElement, Component } from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';
import json2mq from 'json2mq';

var isMatchMediaSupported = typeof global.matchMedia === 'function';

var queryToMql = function queryToMql(query) {
  return global.matchMedia(json2mq(query));
};
var createMediaMatcher = function createMediaMatcher(query) {
  var mql = queryToMql(query);

  return {
    matches: mql.matches,
    subscribe: function subscribe(handler) {
      mql.addListener(handler);

      return function () {
        return mql.removeListener(handler);
      };
    }
  };
};

var withMatchMediaProps = function withMatchMediaProps() {
  var propsQieries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Target) {
    if (!isMatchMediaSupported) {
      return Target;
    }

    var WithMatchMediaProps = function (_Component) {
      _inherits(WithMatchMediaProps, _Component);

      function WithMatchMediaProps(props, context) {
        _classCallCheck(this, WithMatchMediaProps);

        var _this = _possibleConstructorReturn(this, (WithMatchMediaProps.__proto__ || Object.getPrototypeOf(WithMatchMediaProps)).call(this, props, context));

        _this.propsMatchers = Object.keys(propsQieries).map(function (prop) {
          return _extends({
            prop: prop
          }, createMediaMatcher(propsQieries[prop]));
        });

        _this.state = _this.propsMatchers.reduce(function (result, propMatcher) {
          return _extends({}, result, _defineProperty({}, propMatcher.prop, propMatcher.matches));
        }, {});
        return _this;
      }

      _createClass(WithMatchMediaProps, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          this.unsubscribers = this.propsMatchers.map(function (propMatcher) {
            return propMatcher.subscribe(function (e) {
              _this2.setState(_defineProperty({}, propMatcher.prop, e.matches));
            });
          });
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.unsubscribers.forEach(function (unsubscribe) {
            return unsubscribe();
          });
        }
      }, {
        key: 'render',
        value: function render() {
          return createElement(Target, _extends({}, this.props, this.state));
        }
      }]);

      return WithMatchMediaProps;
    }(Component);

    if (process.env.NODE_ENV !== 'production') {
      return setDisplayName(wrapDisplayName(Target, 'withMatchMediaProps'))(WithMatchMediaProps);
    }

    return WithMatchMediaProps;
  };
};

export default withMatchMediaProps;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hocs/with-match-media-props/build/browser-esm/index.js
// module id = 16
// module chunks = 249